import { create } from 'zustand';
import { getData, setData } from '@/utils/storage';

const DEFAULT_SETTINGS = {
  whatsappNumber: '0500000000',
  whatsappMessage: ''
};

export const useSettingsStore = create((set) => ({
  settings: getData('appSettings', DEFAULT_SETTINGS),
  
  updateSettings: (newSettings) => {
    set((state) => {
      const updatedSettings = { ...state.settings, ...newSettings };
      setData('appSettings', updatedSettings);
      return { settings: updatedSettings };
    });
  },
}));